import React from 'react';
import { array, object, string, bool } from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Icon from 'yoda-core-components/lib/components/Icon';
import Check from 'yoda-core-components/lib/assets/svg/Check.svg';
import Close from 'yoda-core-components/lib/assets/svg/Close.svg';
import Mouse from 'yoda-core-components/lib/assets/svg/Mouse.svg';
import Warning from 'yoda-core-components/lib/assets/svg/Warning.svg';
import { cardTypes } from '../../ProductCard.config';
import styles from './ProductAvailability.css';

const cx = classNames.bind(styles);

export const ProductAvailability = (props) => {
    const {
        deviceType: { isDesktop },
        cardType,
        enableProductAvailability,
        availabilityStatus,
    } = props;

    const displayProductAvailability =
        enableProductAvailability && // Feature flag for Product Availability
        isDesktop &&
        cardType === cardTypes.GRID && // Display Product Availability only in GRID view
        availabilityStatus?.length; // Availability status info

    if (displayProductAvailability) {
        const iconMap = {
            mouse: <Mouse />,
            cross: <Close />,
            warning: <Warning />,
        };

        const messageClasses = `${dt(['font-sans', 'font-semibold', 'text-black', 'text-xs'])} ${cx(
            'product-availability-message'
        )}`;

        const availabilityItems = availabilityStatus.map((item, index) => {
            let { storeName } = item;
            const { message } = item;
            if (storeName?.length > 19) storeName = `${storeName.slice(0, 19)}...`;
            const content = (
                <div
                    className={dt(['flex'])}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${storeName}-product-availability-message-${index}`}
                >
                    <Icon automationId="check-automation-swatch" height="24" width="24">
                        {iconMap[availabilityStatus[index].icon] || <Check />}
                    </Icon>
                    <div className={dt(['ml-2', 'mt-2'])}>
                        {/* eslint-disable react/no-danger */}
                        <div
                            className={messageClasses}
                            dangerouslySetInnerHTML={{ __html: message }}
                        />
                        {storeName ? <div>{storeName}</div> : null}
                    </div>
                </div>
            );
            return content;
        });

        return <>{availabilityItems}</>;
    }

    return null;
};

ProductAvailability.defaultProps = {
    cardType: '',
    enableProductAvailability: false,
    availabilityStatus: [],
};

ProductAvailability.propTypes = {
    deviceType: object.isRequired,
    cardType: string,
    enableProductAvailability: bool,
    availabilityStatus: array,
};

/* istanbul ignore next */
const mapStateToProps = ({ context }) => ({
    enableProductAvailability: context?.featureFlags?.enableProductAvailability ?? false,
});

export default connect(mapStateToProps)(ProductAvailability);
